import React from 'react'

const Content = ({ children }) => {
  return (
    <main id='js-page-content' role='main' className='page-content'>
      {children}
    </main>)
}

export default Content
